module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('LinkPath', {
    attrs: {
      "current-path": "atualização de agentes"
    }
  }), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('form', {
    staticStyle: {
      "padding": "10px !important"
    },
    attrs: {
      "id": "formBio"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "margin": "16px",
      "display": "none"
    },
    attrs: {
      "id": "divAlert",
      "role": "alert"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "agent-input-group"
  }, [_c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "col-md-4 mb-3"
  }, [_c('label', {
    attrs: {
      "for": "cpf"
    }
  }, [_vm._v("CPF")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cpf),
      expression: "cpf"
    }],
    staticClass: "form-control cpf",
    attrs: {
      "type": "text",
      "id": "cpf"
    },
    domProps: {
      "value": (_vm.cpf)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cpf = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group pesquisa-box"
  }, [_c('div', {
    staticClass: "col-md-1 mb-3"
  }, [_c('button', {
    staticClass: "btn btn-primary search-button",
    attrs: {
      "id": "btnPesq",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.searchAgent()
      }
    }
  }, [_vm._v("\n                      Pesquisar\n                    ")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    attrs: {
      "id": "divUserAgent"
    }
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "tabUser_wrapper"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "tabUser",
      "role": "grid",
      "id": "tabUser"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.listaAgents), function(agent, index) {
    return _c('tr', {
      key: agent.id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(agent.agent.username))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(agent.agent.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(agent.createDateFormat))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(agent.operator))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(agent.updateDateFormat))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": "#",
        "data-toggle": "modal",
        "data-target": "#agentModal",
        "title": "Ativar/Inativar Update de Agente"
      },
      on: {
        "click": function($event) {
          _vm.activeAgent(index);
          _vm.toggleClassByName('show', '#agentModal')
        }
      }
    }, [_vm._v(_vm._s(agent.enabled ? "ATIVO" : "INATIVO"))])])])
  }), 0), _vm._v(" "), _vm._m(2)])])])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal .collapse.show",
    attrs: {
      "id": "agentModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "agentModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("Deseja " + _vm._s(_vm.enabled ? "desautorizar" : "autorizar") + " o agente de registro " + _vm._s(_vm.agentName) + " à efetuar sua\n              atualização biométrica?")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.updateAgent()
      }
    }
  }, [_vm._v("Sim")])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "dataTables_length",
    attrs: {
      "id": "tabUser_length"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticClass: "sorting_asc",
    staticStyle: {
      "width": "167px"
    },
    attrs: {
      "aria-sort": "ascending",
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "tabUser",
      "tabindex": "0"
    }
  }, [_vm._v("Agente\n                              ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "207px"
    },
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "tabUser",
      "tabindex": "0"
    }
  }, [_vm._v("Nome\n                              ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "182px"
    },
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "tabUser",
      "tabindex": "0"
    }
  }, [_vm._v("Data de Cadastro\n                              ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "182px"
    },
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "tabUser",
      "tabindex": "0"
    }
  }, [_vm._v("Cadastrado por\n                              ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "182px"
    },
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "tabUser",
      "tabindex": "0"
    }
  }, [_vm._v("Data de Atualização\n                              ")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    staticStyle: {
      "width": "182px"
    },
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "tabUser",
      "tabindex": "0"
    }
  }, [_vm._v("Status\n                              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tfoot', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Agente")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Data de Cadastro")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Cadastrado por")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Data de Atualização")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_vm._v("Status")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header agente-modal-header"
  }, [_c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "color": "white",
      "font-weight": "bold"
    },
    attrs: {
      "id": "agentModalLabel"
    }
  }, [_vm._v("Autorizar\n              Atualização de Agente")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b62267f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/interfaces/views/AgentsUpdate.vue
// module id = 266
// module chunks = 0